import {CheckboxOption, FormControl, FormField, Separator} from 'platform/components';
import {Heading, VStack} from 'platform/foundation';

import {UseFormReturn, useWatch} from 'react-hook-form';

import {isNotEmpty, not} from 'ramda';

import {UpdateScopeWarehouseArticle} from '@dms/api/warehouse';
import i18n from '@dms/i18n';

import {isNotNilOrEmpty, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {OverviewForm} from '../types/OverviewForm';

interface WarehouseArticleUpdateScopeProps extends RequiredTestIdProps {
  control: FormControl<OverviewForm>;
  formApi: UseFormReturn<OverviewForm>;
}

export function WarehouseArticleUpdateScope(props: WarehouseArticleUpdateScopeProps) {
  const [shouldUpdateAll, currentScope] = useWatch({
    control: props.control,
    name: ['updateScope.updateScopeWarehouseArticleAll', 'updateScope.updateScopeWarehouseArticle'],
  });

  const handleUpdateAllChange = (value: boolean) => {
    if (value) {
      props.formApi.setValue(
        'updateScope.updateScopeWarehouseArticle',
        options.map((option) => option.value as UpdateScopeWarehouseArticle)
      );
      return;
    }
    props.formApi.setValue('updateScope.updateScopeWarehouseArticle', []);
  };

  const handleScopeChange = (value: string[] | null) => {
    const hasAllOptionsSelected =
      isNotNilOrEmpty(value) && options.every((option) => value?.includes(option.value));

    props.formApi.setValue('updateScope.updateScopeWarehouseArticleAll', hasAllOptionsSelected);
  };

  const hasSomeOptionsSelected = not(shouldUpdateAll) && isNotEmpty(currentScope);

  return (
    <VStack spacing={4}>
      <Heading size={5}>{i18n.t('entity.warehouse.labels.warehouseArticle')}</Heading>
      <FormField
        isDisabled
        isIndeterminate={hasSomeOptionsSelected}
        control={props.control}
        type="checkbox"
        name="updateScope.updateScopeWarehouseArticleAll"
        label={i18n.t('entity.warehouse.labels.updateAll')}
        onChange={handleUpdateAllChange}
        data-testid={suffixTestId('inputs.updateAll', props)}
      />
      <Separator spacing={0} />
      <FormField
        control={props.control}
        type="checkboxes"
        name="updateScope.updateScopeWarehouseArticle"
        options={options}
        onChange={handleScopeChange}
        direction="vertical"
        data-testid={suffixTestId('inputs.warehouseArticleScope', props)}
      />
    </VStack>
  );
}

const options: CheckboxOption[] = [
  {
    label: i18n.t('entity.warehouse.labels.recommendedPrice(defSupplier)'),
    value: 'RECOMMENDED_PRICE',
    isDisabled: true,
  },
  {
    label: i18n.t('entity.warehouse.labels.name'),
    value: 'NAME',
    isDisabled: true,
  },
  {
    label: i18n.t('entity.warehouse.labels.discountGroup(defSupplier)'),
    value: 'SUPPLIER_DISCOUNT_GROUP',
    isDisabled: true,
  },
];
